import { createSlice } from "@reduxjs/toolkit";
import { UploadedTriplicatesPatientSign } from "../../apis/dispense/uploadTriplicatesPatientSign";

const initialState = {
    loading: false,
    data: null,
    error: null,
}

const UploadedTriplicatesPatientSignSlice = createSlice({
    name: 'UploadedTriplicatesPatientSign',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(UploadedTriplicatesPatientSign.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(UploadedTriplicatesPatientSign.fulfilled.type, (state, action) => {

            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(UploadedTriplicatesPatientSign.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})


export default UploadedTriplicatesPatientSignSlice.reducer